import './NavBar.scss';
import cn from 'classnames';
import { memo, ReactNode, useRef, useState } from 'react';
import { useNavLocations } from '../../utils/routing/location-utils';
import { ClientSelector } from './ClientSelector/ClientSelector';
import { Expander } from './Expander';
import { LogOut } from './LogOut';
import { NavGroup } from './NavGroup';
import { PageSearch } from './PageSearch/PageSearch';
import { useNavClickOutside } from './useNavBarPopover';
import { DirectNavLink } from './DirectNavLink';

export const NavBar = memo((): ReactNode => {
  const { fullLocations } = useNavLocations();
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  useNavClickOutside(navRef);

  return (
    <div data-testid='navbar' className={cn('bpm-nav', { expanded })} ref={navRef}>
      <ClientSelector />
      <PageSearch />
      {fullLocations.map(group =>
        group.isDirect ? (
          <DirectNavLink key={group.key} navGroup={group} />
        ) : (
          <NavGroup key={group.key} navGroup={group} />
        )
      )}
      <Expander setExpanded={setExpanded} />
      <LogOut />
    </div>
  );
});
